export const GOOGLE_ADS_GROUP = "GoogleAds";
